<template>
  <v-form ref="landingPageEditForm" v-model="valid" class="landing-page-page">
    <v-row>
      <div class="back-btn" @click="$router.push({name: 'news-index'})">
        <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M36 27H23.83L29.42 21.41L28 20L20 28L28 36L29.41 34.59L23.83 29H36V27Z" fill="#8C959D"/>
        </svg>
      </div>
      <v-col cols="12">
        <h1>Посадочная страница</h1>
      </v-col>
      <v-tabs v-model="tab">
        <v-tab>Информация</v-tab>
        <v-tab>SEO</v-tab>
      </v-tabs>
      <v-col cols="12" sm="8" md="5" xl="4">
        <v-tabs-items v-model="tab">
          <v-tab-item :eager="true">
<!--            <v-img :src="previewImage(image)" width="246" height="195" class="mb-8">-->
<!--              <template v-slot:placeholder>-->
<!--                <div class="image-placeholder"></div>-->
<!--              </template>-->
<!--            </v-img>-->
<!--            <v-file-input label="Картинка"-->
<!--                          prepend-icon=""-->
<!--                          class="cursor-pointer"-->
<!--                          outlined-->
<!--                          placeholder="1768х1402"-->
<!--                          append-icon="mdi-attachment"-->
<!--                          v-model="image">-->
<!--            </v-file-input>-->
            <v-text-field
                v-model="landingPage.name"
                label="Название"
                outlined
            ></v-text-field>
            <v-text-field
                v-model="landingPage.slug"
                label="URL"
                outlined
            ></v-text-field>
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="landingPage.data.title"
                        label="Заголовок"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="landingPage.data.under_title"
                        label="Строка под заголовком"
                        outlined
                    ></v-text-field>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="landingPage.data.text" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="landingPage.data.title_ua"
                        label="Заголовок"
                        outlined
                    ></v-text-field>
                    <v-text-field
                        v-model="landingPage.data.under_title_ua"
                        label="Строка под заголовком"
                        outlined
                    ></v-text-field>
                    <editor api-key="8z95zxrw4xtjnn7a2unyi14ym91kzk8j6549luv0ow3cmn2i" v-model="landingPage.data.text_ua" :init="{}" :toolbar="toolbar" :plugins="plugins"/>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-radio-group
                  v-model="landingPage.type"
                  row
              >
                <v-radio
                    label="Главная"
                    value="home"
                ></v-radio>
                <v-radio
                    label="Категория"
                    value="category"
                ></v-radio>
              </v-radio-group>
              <v-select
                  v-if="landingPage.type === 'category'"
                  :items="categories"
                  :item-text="category => category.name"
                  :item-value="category => category.id"
                  v-model="landingPage.data.category"
                  label="Категория"
                  outlined
                  :rules="[rules.required]"
                  required
              ></v-select>
            </v-tabs-items>
          </v-tab-item>
          <v-tab-item :eager="true">
            <v-tabs v-model="tabLang">
              <v-tab>RU</v-tab>
              <v-tab>UA</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabLang">
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="landingPage.data.seo_title"
                        label="SEO Title"
                        outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="landingPage.data.seo_description"
                        label="SEO Description"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
              <v-tab-item :eager="true">
                <v-row>
                  <v-col>
                    <v-text-field
                        v-model="landingPage.data.seo_title_ua"
                        label="SEO Title"
                        outlined
                    ></v-text-field>
                    <v-textarea
                        v-model="landingPage.data.seo_description_ua"
                        label="SEO Description"
                        outlined
                    ></v-textarea>
                  </v-col>
                </v-row>
              </v-tab-item>
            </v-tabs-items>
          </v-tab-item>
        </v-tabs-items>

        <v-btn v-if="id" @click="update">Сохранить</v-btn>
        <v-btn v-else @click="create">Создать</v-btn>
      </v-col>
      <v-snackbar
          v-model="snackbar"
          :timeout="timeout"
          :color="snackbarColor"
          right
          top
      >
        {{ snackbarText }}
      </v-snackbar>
    </v-row>
  </v-form>
</template>

<script>
// @ is an alias to /src
import LandingPageService from './../../api/LandingPageService'
import Editor from '@tinymce/tinymce-vue'
import CategoryService from "@/api/CategoryService";
export default {
  name: 'LandingPageEdit',
  props: {
    id: [Number, String]
  },
  components: {Editor},
  data: () => ({
    plugins: 'advlist autolink lists link image charmap print preview anchor searchreplace visualblocks code fullscreen insertdatetime media table paste code help wordcount',
    toolbar: 'undo redo | formatselect | bold italic backcolor | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | removeformat | code ',
    snackbar: false,
    timeout: 2000,
    snackbarText: '',
    snackbarColor: '',
    rules: {
      required: value => !!value || 'Нужно заполнить',
      requiredSelect: [(v) => !!v.id || 'Нужно заполнить'],
    },
    valid: true,
    image: null,
    tab: '',
    tabLang: '',
    categories: [],
    landingPage: {
      name: "",
      slug: "",
      data: {
        title: '',
        title_ua: '',
        under_title: '',
        under_title_ua: '',
        text: '',
        text_ua: '',
        seo_title: '',
        seo_title_ua: '',
        seo_description: '',
        seo_description_ua: '',
        image_url: '',
        image: '',
        category: null,
      },
      type: 'home'
    },
    loading: true,
    loadingButton: false,
  }),
  mounted() {
    CategoryService.list().then(response => {
      this.categories = response.data
    });

    if(this.id){
      LandingPageService.get(this.id)
          .then(response => {
            this.landingPage = response.data;
            this.landingPage.data.category = parseInt(this.landingPage.data.category);
            if (this.landingPage.data.image) {
              this.image = {}
              this.image.url = this.landingPage.data.image_url;
              this.image.name = this.landingPage.data.image
            }
            this.loading = false
          });
    }

  },
  methods: {
    validate() {


    },
    previewImage(image) {
        if (this.image && this.image.url) {
          return this.image.url
        }

      if (image) {
        return URL.createObjectURL(image)
      }
    },
    create() {

      this.loadingButton = true;
      let formData = this.getData();

      LandingPageService.create(formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
        this.$router.push({ name: 'landing-page-edit', params: { id: response.data.id } })
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    update() {

      this.loadingButton = true;
      let formData = this.getData();
      let id = this.id

      LandingPageService.update(id, formData).then(response => {
        this.snackbar = true;
        this.snackbarText = 'Страница успешно обновлена';
        this.snackbarColor = 'success';
      }).catch(error => {
        this.snackbar = true;
        this.snackbarText = 'Ошибка при обновлении страницы';
        this.snackbarColor = 'error';
      }).finally(() => {
        this.loadingButton = false
      })
    },
    getData() {
      let formData = new FormData();

      formData.append('data[title]', this.landingPage.data.title);
      formData.append('data[under_title]', this.landingPage.data.under_title);
      formData.append('data[title_ua]', this.landingPage.data.title_ua);
      formData.append('data[under_title_ua]', this.landingPage.data.under_title_ua);
      formData.append('data[text]', this.landingPage.data.text);
      formData.append('data[text_ua]', this.landingPage.data.text_ua);
      formData.append('type', this.landingPage.type);
      formData.append('name', this.landingPage.name);
      formData.append('slug', this.landingPage.slug);
      formData.append('data[category]', this.landingPage.data.category ? parseInt(this.landingPage.data.category) : null);
      formData.append('data[seo_title]', this.landingPage.data.seo_title);
      formData.append('data[seo_title_ua]', this.landingPage.data.seo_title_ua);
      formData.append('data[seo_description]', this.landingPage.data.seo_description);
      formData.append('data[seo_description_ua]', this.landingPage.data.seo_description_ua);
      formData.append('data[image]', this.landingPage.data.image);
      formData.append('data[image_url]', this.landingPage.data.image_url);

      if (this.image && !this.image.url) {
        formData.append('image', this.image);
      }

      return formData;
    }
  },
}
</script>

<style lang="scss">
.landing-page-page {
  .v-input__append-inner {
    margin-top: 13px !important;
  }
}
</style>

<style scoped lang="scss">
.landing-page-images .v-image {
  max-height: 374px;
}

.mobile {
  width: 300px;
  height: 300px;
  margin-bottom: 24px;
}

.landing-page {
  position: relative;

  &:before {
    content: "";
    padding-top: 100%;
    display: block;
  }

  .content {
    position: absolute;
    width: 100%;
    left: 0;
    top: 0;
    height: 100%;
    background-color: #F8FBFF;
    border-right-style: 3px;

    .img {
      height: 3.541vw;
      margin-top: .83vw;
    }

    .name {
      margin-top: .72vw;
      text-align: center;
      color: #8C959D;
    }
  }
}
</style>
